import { Database } from './../database';
import { Injectable } from "@angular/core";
import 'rxjs/add/operator/map';

@Injectable()
export class BllKasalar extends Database{
eklenecek_kasalar=[];

    constructor(){
        super("NL_Kasa");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-kasalar.ts